module.exports = __webpack_public_path__ + "img/c03_buildingtechscalemail_Normal_ua.0054854f.webp";